import React, { useRef, useState, Suspense, useEffect } from "react";
import "./index.scss";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router";
import useWebWorker from "../../hooks/useWebWorker";
import Notificaitons from "../../assets/images/notification.svg";
import blueNotifications from "../../assets/images/blueNotifications.svg";
import ExpandImg from "../../assets/images/expand.svg";
import { userNotificationActions } from "../../store/actions/UserNotificationAction";
import { toggleSidebar as toggleSidebarAction } from "../../store/actions/SidebarActions";
import { getUserNotification, storeUserNotifications } from "../../apis/userNotificationsApi";
import { locationTo } from "../Notifications/util";
import { UnsavedChangesDialog, useUnsavedChangesWarning } from "../common/NavigationPrompt";
import ProfileDropdown from "../ProfileDropdown";

const NotificationsDropDown = React.lazy(() => import("../Notifications/NotificationsDropdown"));
const OutOfOfficeNotification = React.lazy(() => import("../OutOfOfficeNotification"));

const Header = () => {
  const User = useSelector((state) => state.UserReducer);
  const isToggle = useSelector((state) => state.SidebarReducer.isToggle);
  const userInformation = User.userInformation;
  const {
    userDetails: { AccessGroup },
  } = useSelector((state) => state.UserDetailsReducer);
  const [notificationCount, setNotificationCount] = useState("");
  const [userNotifications, setUserNotifications] = useState([]);
  const [openNotification, setOpenNotification] = useState(false);
  const [openProfileDropdown, setOpenProfileDropdown] = useState(false);
  const [loader, setLoader] = useState(false);
  const notificationRef = useRef(null);
  const profileDropdownRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const locationPath = location?.pathname;
  const url = locationPath?.split("/");
  const userId = localStorage.getItem("userId");
  const { result } = useWebWorker({ userId });
  const dispatch = useDispatch();
  const [showDialog, setShowDialog] = useState(false);
  const [outOfOFficeNotification, setOutOfNotification] = useState(false);
  const [pendingArg, setPendingArg] = useState(null);
  const [pendingNotification, setPendingNotification] = useState(null);
  const { markDirty, markClean } = useUnsavedChangesWarning();

  useEffect(() => {
    const handleNotificationClick = () => {
      if (notificationRef?.current?.isVisible) {
        setOpenNotification(false);
      }
    };

    document.addEventListener("click", handleNotificationClick, true);

    return () => document.removeEventListener("click", handleNotificationClick, true);
  }, []);

  const roleFormat = () => {
    return AccessGroup?.map((role) => {
      return role.AccessGroupNames.substr(4);
    }).join(", ");
  };
  const handleNotifications = (e) => {
    setOpenNotification(!openNotification);
    notificationRef.current.toggle(e);
  };

  const handleProfileDropdown = (e) => {
    setOpenProfileDropdown(!openProfileDropdown);
    profileDropdownRef.current.toggle(e);
  };

  const handleExpandSidebar = () => {
    dispatch(toggleSidebarAction(false));
  };

  useEffect(() => {
    if (result?.UserNotification || result?.pyCount) {
      dispatch(userNotificationActions(result));
    }
  }, [result]);

  const userNotificationsDetails = useSelector(
    (state) => state.UserNotificationReducer.userNotificationsDetails,
  );
  useEffect(() => {
    if (notificationCount !== userNotificationsDetails?.pyCount) {
      setNotificationCount(userNotificationsDetails?.pyCount);
      if (userNotificationsDetails?.UserNotification?.length >= 1) {
        setUserNotifications([...userNotificationsDetails.UserNotification]);
      }
    }
  }, [userNotificationsDetails]);
  const handleUserNotifications = async (arg, notification) => {
    let formData = {};
    if (arg === "ClearAll") {
      setLoader(true);
      formData = {
        User: userId,
        ClearAll: true,
      };
    } else if (arg === "MarkAllRead") {
      setLoader(true);
      formData = {
        User: userId,
        MarkAllRead: true,
      };
    } else {
      notification.IsRead = true;
      formData = {
        User: userId,
        MarkAllRead: false,
        ClearAll: false,
        ProjectID: notification.AWMProjectID,
        UserNotification: [{ ...notification }],
      };

      const { NotificationType, AWMTaskID, AWMProjectID, LinksTo } = notification;

      if (NotificationType === "Change") {
        const [DSBP_InitiativeID, DSBP_PMP_PIMaterialID, DSBP_PMP_PIMaterialNumber] =
          AWMTaskID.split("/");

        // Build dynamic path based on current location
        let basePath = `/${url[1] || "myProjects"}`; // fallback to myProjects if no context
        let screenPath = "";

        // Determine screen type from current URL
        if (url[2] === "artworkAlignment" || (url[2] === "DSBP" && url[4] === "artworkAlignment")) {
          screenPath = "/artworkAlignment";
        } else if (
          url[2] === "dependencyMapping" ||
          (url[2] === "DSBP" && url[4] === "dependencyMapping")
        ) {
          screenPath = "/dependencyMapping";
        } else if (url[2] === "artworkStatus") {
          screenPath = "/artworkStatus";
        } else if (url[2] === "DSBP" && url[4]) {
          screenPath = `/DSBP/tab/${url[4]}`;
        } else {
          // Default fallback to artworkAlignment if we can't determine the screen
          screenPath = "/artworkAlignment";
        }

        const changeHandlingUrl = `${basePath}${screenPath}/ChangeHandling/${userId}/${AWMProjectID}`;
        navigate(changeHandlingUrl, {
          state: {
            from: "notification",
            assignee: userId,
            InitiativeID: DSBP_InitiativeID,
            PIMaterialID: DSBP_PMP_PIMaterialID,
            PIMaterialNumber: DSBP_PMP_PIMaterialNumber,
          },
        });
      } else {
        navigate(locationTo(NotificationType, AWMTaskID, AWMProjectID, userId, LinksTo));
      }
    }
    await storeUserNotifications(formData);
    let result = await getUserNotification(userId);
    setUserNotifications(result?.UserNotification);
    setNotificationCount(result?.pyCount);
    dispatch(userNotificationActions(result));
    setLoader(false);
  };

  //by doing this will call the popup/handleUserNotifications depending on unsavedChanges
  const handleUserNotificationsCall = (arg, notification) => {
    const unsavedChanges = JSON.parse(localStorage.getItem("unsavedChanges"));
    if (unsavedChanges) {
      setPendingArg(arg);
      setPendingNotification(notification);
      setShowDialog(true);
    } else {
      handleUserNotifications(arg, notification);
    }
  };
  // it will hide warning dialog
  const cancelNavigation = () => {
    setShowDialog(false);
  };
  // by doing setShowDialog(false) and will call handleUserNotifications ;
  const confirmNavigation = () => {
    handleUserNotifications(pendingArg, pendingNotification);
    markClean();
    setShowDialog(false);
  };

  // it will hide out of office dialog
  const cancelNotification = () => {
    setOutOfNotification(false);
  };

  return (
    <div className="header">
      <div className="header-title-container">
        {isToggle && (
          <img
            src={ExpandImg}
            alt="expand sidebar"
            className="expand-icon"
            onClick={handleExpandSidebar}
          />
        )}
        <h1>
          Welcome Back, {userInformation?.firstName} ({roleFormat()})!
        </h1>
      </div>
      <div className="user-profile">
        <img
          src={openNotification ? blueNotifications : Notificaitons}
          alt="notificaitons"
          className="notificaitons"
          onClick={(e) => handleNotifications(e)}
        />
        {notificationCount > 0 && userInformation?.username && (
          <span className="notification-badge">
            {notificationCount > 10 ? "10+" : notificationCount}
          </span>
        )}
        <Suspense fallback={<div></div>}>
          <NotificationsDropDown
            notificationRef={notificationRef}
            userNotifications={userNotifications}
            userId={userInformation?.userid}
            setUserNotifications={setUserNotifications}
            setNotificationCount={setNotificationCount}
            handleUserNotifications={handleUserNotificationsCall}
            loader={loader}
          />
        </Suspense>
        <div className="userInfoSection">
          <p className="userInfo">
            {userInformation?.firstName}
            <span>{userInformation.userid}</span>
          </p>
          <button onClick={(e) => handleProfileDropdown(e)} className="dropdownBtn">
            <i
              className={`pi pi-angle-${openProfileDropdown ? "up" : "down"}`}
              style={{ fontSize: "1.5rem", color: "rgb(172, 172, 172)" }}
            ></i>
          </button>
        </div>
        <Suspense fallback={<div></div>}>
          <ProfileDropdown
            profileDropdownRef={profileDropdownRef}
            loader={loader}
            setOutOfNotification={setOutOfNotification}
            handleProfileDropdown={handleProfileDropdown}
          />
        </Suspense>

        {/* UnsavedChangesDialog popup*/}
        <UnsavedChangesDialog
          visible={showDialog}
          onCancel={cancelNavigation}
          onConfirm={confirmNavigation}
        />
        {/* <img src={user} alt="user profile" className="userProfile" /> */}
        <OutOfOfficeNotification visible={outOfOFficeNotification} onCancel={cancelNotification} />
      </div>
    </div>
  );
};
export default Header;
